import React from 'react';
import { Modal } from 'antd';
import Children from './Children';
/**
 * 头部OK按钮
 * @param {*} param
 */
const ModalML = (props) => {
  let { visible, title, okText, cancelText, handleOk, handleCancel } = props;

  return (
    <div>
      <Modal
        title={null}
        centered={true} // 垂直居中展示modal
        visible={visible}
        onOk={handleOk}
        footer={null}
        closable={false}
      >
        <Children
          title={title}
          okText={okText}
          cancelText={cancelText}
          handleOk={handleOk}
          handleCancel={handleCancel}
        />
      </Modal>
    </div>
  );
};

export default ModalML;
